// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tutorial-list_wrapper__2TJFO"};